import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash';

import InitialState from './data/InitialState';

import { changeQty, changeVariant } from './slice/basic_changers';
import { remove_from_cart, remove_accessory_from_cart } from './slice/removers';
import { selectAccessory } from './slice/selectAccessory';

const accesoriesService = createSlice({
  name: 'accesoriesService',
  initialState: InitialState,
  reducers: {
    changeAccessoryQuantity: (state, action) => {
      const { quantity, index } = action.payload;
      changeQty(state, index, quantity)
    },
    changeAccessoryVariant: (state, action) => {
      const { variant, index } = action.payload;
      changeVariant(state, index, variant)
    },
    changeAccessorySelected: (state, action) => {
      const {index} = action.payload;
      selectAccessory(state, index)
    },
    removeAll(state){
      remove_from_cart(state)
    },
    removeAccessory: (state, action) => {
      const {product_id} = action.payload;
      remove_accessory_from_cart(state, product_id)
    },
  },
  extraReducers: (builder) => {}
})

export const {
  changeAccessoryQuantity,
  changeAccessorySelected,
  changeAccessoryVariant,
  removeAll,
  removeAccessory,
} = accesoriesService.actions;

export default accesoriesService.reducer;